import { useEffect, useState } from "react";
import { InputDate } from "../../../../../theme/Input/InputDate";
import { IncapacityTypeConstantsEditor } from "../../../../../Talentohumano/GestionTH/EmployeeIncapacity/IncapacityEditors/IncapacityTypeConstants.editor";
import { LiquidateMonthConstantsEditor } from "../../../../../Talentohumano/GestionTH/EmployeeIncapacity/IncapacityEditors/LiquidateMonthConstantsEditor";
import { toast } from "react-toastify";
import { _EmployeeIncapacity, _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { BasicSwitch } from "../../../../../theme/Component/BasicSwitch";
import { AccountEditor } from "../../../../../editor/AccountEditor";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";

interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure: ProcedureFunctions;
}

export const THIN002 = ({ configProcedure }: Props) => {

    const { instance, bean, setBean } = useDataBean(_EmployeeIncapacity);
    const [props, setProps] = useState<any>({})

    useEffect(() => {
        if (configProcedure?._pocessData?.Props) {
            setProps(configProcedure?._pocessData?.Props)
        }
    }, [configProcedure?._pocessData])

    useEffect(() => {
        setBean({
            ...props,
            Year: _single.getCurrenYear(),
            Days_90: false,
            Days_180: false,
            LiquidateToTotalSalary: false,
            IDEmployee: _single.getAccountID(),
        })
    }, [props])

    const onExportMap = (info: any) => {

        console.log(info)

        if (configProcedure?._pushInfo) {
            configProcedure?._pushInfo(info.Description)
        }
        if (configProcedure?._exportMap) {
            configProcedure?._exportMap(info)
        }
        if (configProcedure?._pushProps) {
            configProcedure?._pushProps(info)
        }
    }

    const [missingFields, setMissingFields] = useState<string[]>([]);

    const validateData = () => {
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            updateItem()
        }
    }

    const validateForm = () => {
        const requiredFields = [
            "Month", "IDAccount", "Year", "Type", "FromDate", "UptoDate", "Description"
        ];
        let missing = [];
        for (let field of requiredFields) {
            if (bean[field] === null || bean[field] === undefined || bean[field] === "") {
                missing.push(field);
            }
        }
        setMissingFields(missing);
        return missing.length;
    };

    const updateItem = () => {
        instance.updateEmployeeIncapacity(bean).then(
            (resp) => {
                onExportMap(resp);
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    return (
        <div className="row">
            {/* <PrintJson json={props} /> */}
            <div className="col-md-6">
                <label className={`${missingFields.includes('IDAccount') ? 'has-error' : ''}`}>Empleado</label>
                <AccountEditor label=" " disabled={props.IDAccount} idAccount={bean.IDAccount} onChange={(e) => { setBean({ ...bean, "IDAccount": e.IDAccount }) }} />
            </div>
            <div className="col-6">
                <label className={`${missingFields.includes('Type') ? 'has-error' : ''}`}>Tipo de Incapacidad</label>
                <IncapacityTypeConstantsEditor idSelector={bean.Type} onChange={(e) => { setBean({ ...bean, "Type": e }) }} label=" " />
            </div>
            <div className="col-6">
                <label className={`${missingFields.includes('FromDate') ? 'has-error' : ''}`}>Inicio en</label>
                <InputDate label=" " name="FromDate" value={bean.FromDate} setDate={(e: any) => { setBean({ ...bean, 'FromDate': e }) }} />
            </div>
            <div className="col-6">
                <label className={`${missingFields.includes('UptoDate') ? 'has-error' : ''}`}>Terminación en</label>
                <InputDate label=" " name="UptoDate" value={bean.UptoDate} setDate={(e: any) => { setBean({ ...bean, 'UptoDate': e }) }} />
            </div>
            <div className="col-6">
                <label className={`${missingFields.includes('Year') ? 'has-error' : ''}`} >Año a Aplicar</label>
                <input type="number" className="form-control" name="Year" value={bean.Year} onChange={(e) => { setBean({ ...bean, "Year": e.target.value }) }} />
            </div>
            <div className="col-6">
                <label className={`${missingFields.includes('Month') ? 'has-error' : ''}`} >Mes a Aplicar</label>
                <LiquidateMonthConstantsEditor label=" " idSelector={bean.Month} onChange={(e) => { setBean({ ...bean, "Month": e }) }} />
            </div>

            <div className="col-6">
                <AccountEditor label="A Cargo de" idAccount={bean.Third} onChange={(e) => { setBean({ ...bean, "Third": e.IDAccount }) }} />
            </div>
            <div className="col-6 d-flex">
                <div className="row d-flex align-content-center">
                    <BasicSwitch label="Prorroga" estado={bean.Extending} eventChange={(e) => { setBean({ ...bean, "Extending": e }) }} />
                </div>
            </div>
            <div className="col-6 d-flex">
                <div className="row d-flex align-content-center">
                    <BasicSwitch label="Hospitalización" estado={bean.Hospitalization} eventChange={(e) => { setBean({ ...bean, "Hospitalization": e }) }} />
                </div>
            </div>
            <div className="col-6 d-flex">
                <div className="row d-flex align-content-center">
                    <BasicSwitch label="+90 Días" estado={bean.Days_90} eventChange={(e) => { setBean({ ...bean, "Days_90": e }) }} />
                </div>
            </div>
            <div className="col-6 d-flex">
                <div className="row d-flex align-content-center">
                    <BasicSwitch label="+180 Días" estado={bean.Days_180} eventChange={(e) => { setBean({ ...bean, "Days_180": e }) }} />
                </div>
            </div>
            <div className="col-6">
                <label >IBC</label>
                <input type="number" className="form-control" name="Ibc" value={bean.Ibc} onChange={(e) => { setBean({ ...bean, "Ibc": e.target.value }) }} />
            </div>
            <div className="col-6 d-flex">
                <div className="row d-flex align-content-center">
                    <BasicSwitch label="Definir IBC" estado={bean.ApplyIBC} eventChange={(e) => { setBean({ ...bean, "ApplyIBC": e }) }} />
                </div>
            </div>
            {bean.ApplyIBC &&
                <div className="col-6">
                    <label >IBC a Aplicar</label>
                    <input type="number" className="form-control" name="IbcToApply" value={bean.IbcToApply} onChange={(e) => { setBean({ ...bean, "IbcToApply": e.target.value }) }} />
                </div>
            }
            <div className="col-12">
                <label className={`${missingFields.includes('Description') ? 'has-error' : ''}`} >Diagnóstico</label>
                <textarea name="Description" className="form-control" value={bean.Description} onChange={(e) => { setBean({ ...bean, "Description": e.target.value }) }} />
            </div>
            <div className="col-6 d-flex">
                <div className="row d-flex align-content-center">
                    <BasicSwitch label="Liquidar al 100% del Salario" estado={bean.LiquidateToTotalSalary} eventChange={(e) => { setBean({ ...bean, "LiquidateToTotalSalary": e }) }} />
                </div>
            </div>
            <div className="col-md-12">
                <BasicButton eventClick={validateData} icon="ri-save-line" children={`Guardar Incapacidad`} />
            </div>
        </div>
    );
}